import { render, staticRenderFns } from "./PaginationNavGoto.vue?vue&type=template&id=30bb5383"
import script from "./PaginationNavGoto.vue?vue&type=script&lang=js"
export * from "./PaginationNavGoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports